import { render, staticRenderFns } from "./main.vue?vue&type=template&id=19f85ac1&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f85ac1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f85ac1')) {
      api.createRecord('19f85ac1', component.options)
    } else {
      api.reload('19f85ac1', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=19f85ac1&scoped=true&", function () {
      api.rerender('19f85ac1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/main.vue"
export default component.exports